<template>
  <!-- We wrap this element to use the error-messages stuff from v-input -->
  <v-input v-bind="$attrs">
    <file-pond
      ref="filepond"
      v-bind="$attrs"
      :label-idle="dropzoneText"
      :allow-multiple="allowMultiple"
      image-preview-height="250"
      :label-file-type-not-allowed="
        $t('fresh-vue-files.FileDropzone.file-type-not-allowed')
      "
      :file-validate-type-label-expected-types="`${$t(
        'fresh-vue-files.FileDropzone.file-type-expected'
      )} {allTypes}`"
      :class="{ multiple: allowMultiple }"
      style="width: 100%"
      @updatefiles="onUpdateFiles"
    />
  </v-input>
</template>

<script>
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

import FileUtils from '../utils/file.js'

import { VInput } from 'vuetify/lib'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview
)

export default {
  name: 'FileDropzone',

  components: {
    FilePond,
    VInput
  },

  props: {
    value: {
      type: [Array, Object],
      required: false,
      default: null
    },

    dropzoneText: {
      type: String,
      required: false,
      default: function () {
        return this.$t('fresh-vue-files.FileDropzone.dropzone-text')
      }
    },

    allowMultiple: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  watch: {
    value(value) {
      if (!value || (Array.isArray(value) && value.length === 0)) {
        // Check if every file is a file with an error. If this is the case, we need to keep the files.
        // Otherwise the errors won't be shown to the user if the only file he uploaded is a file with an error.
        // If there are files without an error, we won't reach this code and can simply ignore this case
        const files = this.$refs.filepond.getFiles()
        if (!files.every((file) => file.status === 8)) {
          this.$refs.filepond.removeFiles()
        }
      }
    }
  },

  methods: {
    getFiles() {
      const filesOrig = this.$refs.filepond.getFiles()
      var _return = []

      filesOrig
        .filter((item) => item.status !== 8) // https://pqina.nl/filepond/docs/api/exports/#filestatus
        .forEach((item) => {
          _return.push(this.createFile(item))
        })

      return _return
    },

    onUpdateFiles() {
      const files = this.getFiles()
      this.$emit('input', this.allowMultiple ? files : files[0])
    },

    createFile(filepondFile) {
      const file = filepondFile.file

      return {
        file: file,
        name: FileUtils.getFilename(file),
        extension: FileUtils.getExtension(file),
        mimetype: FileUtils.getMimetype(file)
      }
    },

    validate() {
      const files = this.$refs.filepond.getFiles()
      return files.every((file) => file.status !== 8) // https://pqina.nl/filepond/docs/api/exports/#filestatus
    },

    // for use in parent component
    isValid() {
      return this.validate()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.filepond--wrapper.multiple::v-deep {
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    .filepond--item {
      width: calc(50% - 0.5em);
    }
  }

  @media #{map-get($display-breakpoints, 'xl-only')} {
    .filepond--item {
      width: calc(33.33% - 0.5em);
    }
  }
}
</style>
